import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { BackendLoyaltyService } from '../../services/backend-loyalty.service';

import { IStatusPointsModel } from '../../models/loyalty/IStatus-Points.model';
import {
  GetStatusPoints,
  GetStatusPointsError,
  GetStatusPointsSuccess,
  GET_STATUS_POINTS,
  StatusPointsActions
} from '../../actions/loyalty/actions-status-points';

@Injectable()
export class EffectsStatusPoints {
  getStatusPoints$: Observable<StatusPointsActions> = createEffect(() => {
    return this.actions$.pipe(
      ofType<GetStatusPoints>(GET_STATUS_POINTS),
      switchMap(request =>
        this.backendLoyaltyService
          .getLoyaltyStatusPoints(
            localStorage.getItem('country_code'),
            request['payload'].details,
            request['payload'].pnrSearch,
            request['payload'].toDate,
            request['payload'].fromDate
          )
          .pipe(
            map((data: IStatusPointsModel) => new GetStatusPointsSuccess(data)),
            catchError(() => of(new GetStatusPointsError('pageSectionIsNotAvailable')))
          )
      )
    )
  });

  constructor(private readonly actions$: Actions, private readonly backendLoyaltyService: BackendLoyaltyService) { }
}
